import { Component, OnInit } from '@angular/core';
import { ChartConfiguration, Chart } from 'chart.js';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProductoService } from '../../producto/producto.service';
import { ReportesService } from '../reportes.service';
import { UsuarioService } from '../../usuario/usuario.service';

@Component({
  selector: 'app-reportes-ventas',
  templateUrl: './reportes-ventas.component.html',
  styleUrls: ['./reportes-ventas.component.scss']
})
export class ReportesVentasComponent implements OnInit {

  desde: string = '';
  hasta: string = '';
  productos: any[] = [];
  productosSelected: any[] = [];
  encargados: any[] = [];
  encargadosSelected: any[] = [];
  tiposPago: any[] = [
    { id: 1, nombre: 'Efectivo' },
    { id: 2, nombre: 'Tarjeta Débito' },
    { id: 3, nombre: 'Tarjeta Crédito' },
    { id: 4, nombre: 'Transferencia' },
    { id: 5, nombre: 'Cheque' },
    { id: 6, nombre: 'Crédito' },
  ];
  tiposPagoSelected: any[] = [];
  tiposDocumento: any[] = [
    { id: 1, nombre: 'Boleta' },
    { id: 2, nombre: 'Factura' },
  ];
  tiposDocumentoSelected: any[] = [];

  tipoVista: 1 | 2 | 3 = 1;
  filtroFecha: number | null = 1;

  data: any = {};

  chartUtilidades: any = null;
  chartConfigUtilidades: ChartConfiguration = {
    type: 'line',
    options: {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          intersect: false
        }
      },
      interaction: {
        mode: 'index'
      }
    },
    data: {
      labels: [],
      datasets: [
        {
          label: 'Utilidades',
          data: []
        }
      ]
    }
  }

  chartVentasGastos: any = null;
  chartConfigVentasGastos: ChartConfiguration = {
    type: 'bar',
    options: {
      maintainAspectRatio: false,
      interaction: {
        mode: 'index'
      },
      plugins: {
        tooltip: {
          intersect: false
        }
      }
    },
    data: {
      labels: [],
      datasets: [
        {
          label: 'Ventas',
          data: []
        },
        {
          label: 'Compras',
          data: []
        },
        {
          label: 'Gastos',
          data: []
        },
      ]
    }
  }

  constructor(
    private service: ReportesService,
    private loading: LoadingService,
    private alerts: AlertService,
    public formatter: FormatterService,
    private productoService: ProductoService,
    private usuarioService: UsuarioService
  ) { }

  ngOnInit(): void {
    this.loadProductos();
    this.setFiltroFecha(3);
    this.cargarEncargados();
  }

  loadProductos() {
    this.loading.show()
    this.productoService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.productos = res
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  cargarEncargados() {
    this.loading.show()
    this.usuarioService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.encargados = res.filter((e: any) => e.rol_id != 4);
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  searchFnEncargado(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.apellido].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  loadData() {
    this.loading.show()
    this.service.ventas(this.desde, this.hasta, this.productosSelected, this.encargadosSelected, this.tiposPagoSelected, this.tiposDocumentoSelected).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.data = res;
        this.displayChart();
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  displayChart() {
    if (this.chartVentasGastos) this.chartVentasGastos.destroy();
    let ventas = this.formatter.parseDataParaReporte(this.data.ventas, this.desde, this.hasta, this.tipoVista, 'monto');
    let gastos = this.formatter.parseDataParaReporte(this.data.gastos, this.desde, this.hasta, this.tipoVista, 'monto');
    let compras = this.formatter.parseDataParaReporte(this.data.compras, this.desde, this.hasta, this.tipoVista, 'monto');
    this.chartConfigVentasGastos.data.labels = ventas.leyenda;
    this.chartConfigVentasGastos.data.datasets[0].data = ventas.result;
    this.chartConfigVentasGastos.data.datasets[1].data = compras.result;
    this.chartConfigVentasGastos.data.datasets[2].data = gastos.result;
    this.chartVentasGastos = new Chart(
      <any>document.getElementById('ventas-gastos'),
      this.chartConfigVentasGastos
    );

    if (this.chartUtilidades) this.chartUtilidades.destroy();
    let utilidades = this.formatter.parseDataParaReporte(this.data.utilidades, this.desde, this.hasta, this.tipoVista, 'monto');
    this.chartConfigUtilidades.data.labels = utilidades.leyenda;
    this.chartConfigUtilidades.data.datasets[0].data = utilidades.result;
    this.chartUtilidades = new Chart(
      <any>document.getElementById('utilidades'),
      this.chartConfigUtilidades
    );
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.sku, item.codigo_barra].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  setFiltroFecha(tipo: any = null) {
    this.filtroFecha = tipo;
    let result = this.formatter.obtenerFiltroFecha(tipo);

    this.desde = result.desde;
    this.hasta = result.hasta;
    this.loadData();
  }

}
